<template functional>
  <div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="row" :class="props.customClass">
        <div
          class="row  col-sm-12"
          :class="{
            'col-md-8': props.showVisitDetails,
            'col-md-12': !props.showVisitDetails,
          }"
        >
          <div
            v-if="props.value.requestNumber"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Número de Solicitud:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.requestNumber | empty }}
            </p>
          </div>
          <div
            v-show="props.showStartDate"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Fecha de Comienzo:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{
                props.value.assignmentStartDate ||
                  props.assignmentStartDate ||
                  '-'
              }}
            </p>
          </div>
          <div
            v-if="props.value.serviceTypeName"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Tipo de Servicio:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.serviceTypeName | empty }}
            </p>
          </div>
          <div
            v-if="props.value.alternativeName"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Nombre de Alternativa:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.alternativeName | empty }}
            </p>
          </div>
          <div
            v-if="props.value.numberOfStudents"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Cantidad de Estudiantes:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.numberOfStudents | empty }}
            </p>
          </div>
          <div
            v-if="props.value.grade"
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Grado:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.grade | empty }}
            </p>
          </div>
          <div
            class="col-sm-12"
            :class="{
              'col-md-3': props.showVisitDetails,
              'col-md-2': !props.showVisitDetails,
            }"
          >
            <span class="font-14 font-weight-normal color-secondary-6">
              Nombre de Asistente:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{ props.value.assistanceName || '-' }}
            </p>
          </div>
          <div v-show="props.showAssignmentDates" class="col-md-3 col-sm-12">
            <span class="font-14 font-weight-normal color-secondary-6">
              Vigencia:
            </span>
            <p class="font-16 font-weight-normal color-black">
              {{
                props.value.assignmentStartDate ||
                  props.assignmentStartDate ||
                  '-'
              }}
              - {{ props.value.assignmentEndDate || props.assignmentEndDate }}
            </p>
          </div>
        </div>
        <div
          v-if="props.showVisitDetails"
          class="col-md-3 col-sm-12 col-spacing d-flex align-items-start visit-day border-left pl-3 pl-md-3 pl-sm-3 mb-2 pt-0 ml-5"
        >
          <div class="flex-grow-1 ml-1 ml-md-0 ml-sm-1">
            <div>
              <div class="color-gray-6 font-14 font-weight-normal">
                Días Registrados en Visitas Regulares:
              </div>
              <div class="d-flex row pl-3 pl-md-3 pl-sm-3">
                <div
                  v-for="(visit, j) in props.visitsRegular"
                  :key="`visit-regular-key-${j}`"
                  class="bg-secondary-2 visit-day__box rounded col-1 mt-1 mr-1"
                >
                  <span class="color-black font-14">
                    {{ visit.visitDay }}
                  </span>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Días Registrados en Ausencia:
              </div>
              <div class="d-flex row pl-md-3 pl-sm-3">
                <div
                  v-for="(visit, j) in props.visitsAbsence"
                  :key="`visit-regular-key-${j}`"
                  class="bg-visit-absence visit-day__box rounded mr-2 col-1 mt-1"
                >
                  <span class="color-black font-14">
                    {{ visit.visitDay }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EducativeAdditionalInfo',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    customClass: {
      type: String,
      default: () => '',
    },
    showAssignmentDates: {
      type: Boolean,
      default: true,
      required: false,
    },
    showVisitDetails: {
      type: Boolean,
      default: false,
      required: false,
    },
    assignmentStartDate: {
      type: String,
      default: () => '-',
    },
    assignmentEndDate: {
      type: String,
      default: () => '-',
    },
    visitsRegular: {
      type: Array,
      default: () => new Array(),
    },
    visitsAbsence: {
      type: Array,
      default: () => new Array(),
    },
    showStartDate: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>
